import { render } from "./ZaikoEpcEventListPage.vue?vue&type=template&id=5fe18bd4"
import script from "./ZaikoEpcEventListPage.vue?vue&type=script&lang=js"
export * from "./ZaikoEpcEventListPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__